// Optional allowlist of skill IDs to show in the demo (VITE_DEMO_SKILL_IDS,
// comma-separated). Hides skills whose media aren't in the tile-archive format
// the OpenSeadragon viewer needs. Empty = show everything (default).
const DEMO_SKILL_IDS = (import.meta.env.VITE_DEMO_SKILL_IDS ?? '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean)

export function filterDemoSkills<T extends { id: string }>(skills: T[]): T[] {
  return DEMO_SKILL_IDS.length > 0 ? skills.filter((s) => DEMO_SKILL_IDS.includes(s.id)) : skills
}
